import 'img-comparison-slider'

document.addEventListener("DOMContentLoaded", function () {
    const sliders = document.querySelectorAll("img-comparison-slider");
    const heroQuoteRight = document.querySelector(".quote-right");
    const heroQuoteLeft = document.querySelector(".quote-left");

    sliders.forEach((slider) => {
        slider.addEventListener("slide", (event) => {
            const sliderValue = event.target.value / 100;
            heroQuoteLeft.style.opacity = sliderValue * sliderValue;
            heroQuoteRight.style.opacity = (1 - sliderValue) * (1 - sliderValue);
        });
    });
});